module.exports = __webpack_public_path__ + "img/deqing.cd83d1b6.png";